/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementSentimentResponse {
    id?: string;
    sentimentScore?: number;
    clipId?: string;
    /** One-sentence explanation per language (keys: MK, EN, AL); absent when not AI-computed
     *  or invalidated by a later polarity change. */
    explanation?: { [key: string]: string };
    /** AI-classified Source Type / Industry Topics / Corporate Topics, as their display labels
     *  ("Market & Competition", not an enum name) - absent/empty on clips analyzed before this
     *  field existed, or when the AI response didn't include it. */
    sourceType?: string;
    industryTopics?: string[];
    corporateTopics?: string[];
}